import { render, staticRenderFns } from "./wx-config.vue?vue&type=template&id=2dd92588&scoped=true"
import script from "./wx-config.vue?vue&type=script&lang=js"
export * from "./wx-config.vue?vue&type=script&lang=js"
import style0 from "./wx-config.vue?vue&type=style&index=0&id=2dd92588&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd92588",
  null
  
)

export default component.exports